export function getPlural(
  selectedItemsCount: number,
  pluralString: string = "s",
  singularString: string = ""
): string {
  return selectedItemsCount > 1 ? pluralString : singularString;
}
